export function displayPrice(price: number): string {
    const priceFloat = Math.round(price) / 100;

    return priceFloat % 1 === 0
        ? priceFloat.toString().concat(',-')
        : priceFloat.toFixed(2).replace('.', ',');
}
